/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="SelectorsModel.js"/>

(function($, _) {
  "use strict";

  var ns = window.nspace("ccc.viz.shared.models");

  /**
   * Data response model is responsible for querying the server-side for data,
   * storing the response, and other views listen for the response to change
   * in order to be updated when new data is retrieved
   */
  ns.DataResponseModel = Backbone.Model.extend({
    initialize: function(options) {
      _.bindAll(this);

      this.validateOptions(options);

      this.dispatcher = options.dispatcher;
      this.selectorsModel = options.selectorsModel;
      this.dataUrl = options.dataUrl;

      // Data responses will be cached
      this.cache = {};

      // Listen for the selector options to change and update our data
      this.selectorsModel.on("change", this.getDataResponseOnChange);
    },

    /**
     * When the selectors model changes, determines how/when to get the data response./
     */
    getDataResponseOnChange: function() {
      throw "The data response change event callback be implemented in sub models.";
    },

    getDataResponse: function() {
      var self, filterString;

      // If there's a pending data load, return the $.Deferred
      if (this.deferredLoad) {
        return this.deferredLoad;
      }

      // New async loading task
      this.deferredLoad = $.Deferred();

      if (!this.selectorsModel.areModelArraysValid()) {
        this.set("response", {});
        // Resolve our async loading task
        this.deferredLoad.resolve();
        this.deferredLoad = null;
        return this.deferredLoad;
      }

      self = this;
      filterString = self.getFilterString();
      // Do we already have the response stored locally?
      if (this.cache.hasOwnProperty(filterString)) {
        setTimeout(function() {
          // Update the model
          self.set("response", self.cache[filterString]);
          self.trigger("idle");

          // Resolve our async loading task
          self.deferredLoad.resolve();
          self.deferredLoad = null;
        }, 0);
        return this.deferredLoad;
      }

      this.trigger("busy");

      // Otherwise, hit the web service
      this.dispatcher.trigger("add-task", {
        name: "data-loading",
        text: "Loading data..."
      });
      $.ajax({
        url: self.dataUrl,
        data: self.getDataParams(filterString),
        complete: function() {
          self.trigger("idle");
          self.dispatcher.trigger("end-task", { name: "data-loading" });

          // Resolve our async loading task
          self.deferredLoad.resolve();
          self.deferredLoad = null;
        },
        success: function(response) {
          // Save for future use
          self.cache[filterString] = response;

          // Update the model
          self.set("response", response);
        }
      });

      return this.deferredLoad;
    },

    /**
     * Allows sub models to pass in custom params to the request specified by the data url.
     * @param filterString The filter string to use as a stub across models.
     */
    getDataParams: function(filterString) {
      throw "The way we get params for the data url must be implemented in sub models.";
    },

    /**
     * Constructs a filter string NameValueCollection from model parameters.
     */
    getFilterString: function() {
      throw "The way we get the filter string must be implemented in sub models.";
    },

    validateOptions: function(options) {
      if (!options.dispatcher) {
        throw "Sub models must be passed an event dispatcher.";
      }

      if (!options.selectorsModel) {
        throw "Sub models must be passed a selectors model.";
      }

      if (!options.dataUrl) {
        throw "Sub models must be passed a url to get data from.";
      }
    }
  });
})(jQuery, _);
